import styles from './ShareDialog.module.scss';
import React from 'react';

export const ShareContent = ({ title, description, children }) => {
  return (
    <>
      <div>
        <div>{title && <h6 className={styles.title}>{title}</h6>}</div>
      </div>
      {description && <p className={`${styles.description}`}>{description}</p>}
      {children}
    </>
  )
}